import React, { useState } from 'react';
import { Modal, primaryButton, secondaryButton } from '../components/ui';
import { plural } from '../lib/text';
import { ReasonField } from './IgnoreDialog';

// Lo que cambia de una acción de grupo a otra: cómo se llama, qué se cuenta y qué les pasa a los updates.
const ACTIONS = {
    unpublish: { title: 'Despublicar seleccionados', verb: 'despublicar', confirm: 'Despublicar', one: 'publicación', many: 'publicaciones',
        effect: 'Dejan de entregarse a esos clientes y vuelven a estar disponibles para ellos.' },
    recover: { title: 'Recuperar seleccionados', verb: 'recuperar', confirm: 'Recuperar', one: 'ignorado', many: 'ignorados',
        effect: 'Vuelven a estar disponibles para esos clientes.' },
    ignore: { title: 'Ignorar publicados', verb: 'ignorar', confirm: 'Ignorar y despublicar', one: 'publicación', many: 'publicaciones' },
};

// Confirmación de una acción de la barra sobre Publicados o Ignorados: nada se hace sin ver antes qué updates y qué
// clientes alcanza. `items` son los updates tildados, cada uno con los clientes (de los elegidos arriba) que lo tienen.
export default function GroupActionDialog({ action, items, chosenAbove, version, onConfirm, onCancel }) {
    const { title, verb, confirm, one, many, effect } = ACTIONS[action];
    const [reason, setReason] = useState('');
    const clients = [...new Set(items.flatMap(item => item.clients))].sort();
    const total = items.reduce((sum, item) => sum + item.clients.length, 0);

    return (
        <Modal title={title} onClose={onCancel} footer={<>
            <button type="button" onClick={onCancel} className={secondaryButton}>Cancelar</button>
            <button type="button" onClick={() => onConfirm(reason.trim())} className={primaryButton}>{confirm}</button>
        </>}>
            <p>Vas a {verb} <strong>{plural(items.length, 'update', 'updates')}</strong> en la versión <span className="font-mono">{version}</span>, para <strong>{plural(clients.length, 'cliente', 'clientes')}</strong>{' '}
                <span className="text-slate-500">({chosenAbove ? 'de los elegidos arriba, los que los tienen' : 'no elegiste ninguno arriba: alcanza a todos los que los tienen'})</span>: <span className="font-mono text-[13px] font-medium">{clients.join(', ')}</span>.</p>
            {action === 'ignore' && <p role="alert" className="p-3 rounded-lg bg-amber-50 border border-amber-200 text-amber-900"><strong>Ignorarlos además los despublica:</strong> dejan de entregarse a esos clientes y pasan a Ignorados, hasta que los recuperes.</p>}
            <ul aria-label="Updates y clientes alcanzados" className="border border-zafiro-200 bg-zafiro-50 rounded-lg divide-y divide-zafiro-100 max-h-56 overflow-y-auto">
                {items.map(item => (
                    <li key={item.name} className="px-3 py-1.5">
                        <p className="font-mono text-[13px] font-medium truncate" title={item.name}>{item.name}</p>
                        <p className="text-xs text-slate-600 break-words">{item.clients.join(', ')}</p>
                    </li>
                ))}
            </ul>
            {effect && <p className="text-xs text-slate-500">{effect}</p>}
            {action === 'ignore' && <ReasonField value={reason} onChange={setReason} shared={total > 1} />}
            <p className="p-3 rounded-lg bg-slate-50"><strong>Total: {plural(items.length, 'update', 'updates')}, {plural(total, one, many)}.</strong></p>
        </Modal>
    );
}
